@if (shown()) {
  <div
    class="fixed bottom-6 right-6 z-50"
    nfClickOutside
    (clickOutside)="closeMenu(false)"
    (keydown.escape)="closeMenu(true)"
  >
    @if (menuOpen()) {
      <div
        #menu
        role="menu"
        [attr.aria-label]="labels.menuTitle"
        class="absolute bottom-16 right-0 mb-1 w-64 overflow-hidden rounded-2xl border border-sk-border bg-sk-surface text-sk-text shadow-xl"
        (keydown)="onMenuKeydown($event)"
      >
        <p class="flex items-center gap-2 border-b border-status-primary-border bg-status-primary-bg px-3.5 py-2.5 text-[11px] font-bold uppercase tracking-widest text-status-primary-fg">
          <sk-icon name="bot" size="sm" />
          {{ labels.menuTitle }}
        </p>
        <div class="py-1.5">
          <button
            type="button"
            role="menuitem"
            class="flex w-full items-center gap-3 px-3.5 py-2.5 text-left hover:bg-sk-surface-hover focus-visible:bg-sk-surface-hover focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:bg-transparent"
            [disabled]="!leapBotEnabled()"
            (click)="chooseAssistant()"
          >
            <span class="grid h-9 w-9 flex-none place-items-center rounded-[10px] bg-status-primary-bg text-status-primary-fg" aria-hidden="true">
              <sk-icon name="message-square" size="sm" />
            </span>
            <span class="min-w-0">
              <span class="block text-[13px] font-semibold">{{ labels.assistant }}</span>
              <span class="block text-[11px] text-sk-text-secondary">{{ leapBotEnabled() ? labels.assistantHint : labels.unavailable }}</span>
            </span>
          </button>
          <a
            role="menuitem"
            class="flex items-center gap-3 px-3.5 py-2.5 hover:bg-sk-surface-hover focus-visible:bg-sk-surface-hover focus-visible:outline-none"
            [href]="statusUrl"
            target="_blank"
            rel="noopener noreferrer"
            (click)="closeMenu(true)"
          >
            <span class="grid h-9 w-9 flex-none place-items-center rounded-[10px] bg-status-success-bg text-status-success-fg" aria-hidden="true">
              <sk-icon name="activity" size="sm" />
            </span>
            <span class="min-w-0">
              <span class="block text-[13px] font-semibold">{{ labels.status }}</span>
              @if (statusLine(); as line) {
                <span class="block text-[11px] text-sk-text-secondary">{{ line }}</span>
              }
              <span class="block text-[11px] text-status-primary-fg">{{ labels.statusLink }}</span>
            </span>
          </a>
        </div>
      </div>
    }

    <button
      #fabButton
      data-leapbot-fab
      type="button"
      class="relative grid h-14 w-14 place-items-center rounded-full bg-sk-primary text-sk-text-inverse shadow-xl hover:bg-sk-primary-hover focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sk-border-focus"
      aria-haspopup="menu"
      [attr.aria-expanded]="menuOpen()"
      [attr.aria-label]="labels.open"
      [attr.aria-describedby]="badge() ? 'nf-fab-badge' : null"
      (click)="toggleMenu()"
    >
      <sk-icon [name]="menuOpen() ? 'x' : 'bot'" size="lg" />
      @if (badge(); as kind) {
        <span
          class="absolute -right-0.5 -top-0.5 h-4 w-4 rounded-full border-2 border-sk-surface"
          [class.bg-status-warning-fg]="kind === 'maintenance'"
          [class.bg-status-error-fg]="kind === 'incident'"
          aria-hidden="true"
        ></span>
        <span id="nf-fab-badge" class="sr-only">{{ badgeText() }}</span>
      }
    </button>
  </div>
}
